// Foundations
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// rxjs
import { finalize, map } from 'rxjs/operators';

// Services
import { PetService } from '@app/services/pet.service';
import { AnalyticsService } from '@app/services/analytics.service';
import { LoadingIndicatorService } from '@app/services/loading-indicator.service';
import { AddPetGQL } from '@app/services/graphql.service';

@Component({
  selector: 'app-dog-profile-welcome',
  templateUrl: './dog-profile-welcome.component.html',
  styleUrls: ['./dog-profile-welcome.component.scss'],
})
export class DogProfileWelcomeComponent implements OnInit {
  form: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private _analytics: AnalyticsService,
    private petService: PetService,
    private loadingIndicatorService: LoadingIndicatorService,
    private addPetMutation: AddPetGQL
  ) {
    this.form = this.fb.group({
      firstName: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }
  // CBW-784 Names

  onBegin() {
    this._analytics.logButtonTap('dogProfile_begin');

    this.petService.newPetName = this.form.controls.firstName.value;
    this.addData();
  }

  // Private Methods
  // ------------------------------------------------------------------------------------

  private addData(): void {
    this.loadingIndicatorService.show();
    this.addPetMutation
      .mutate({
        petInput: {
          // CBW-784 Names
          firstName: this.form.get('firstName').value,
        },
      })
      .pipe(
        map((res) => res.data.addPet),
        finalize(() => this.loadingIndicatorService.hide())
      )
      .subscribe((pet) => {
        if (pet) {
          this.router.navigate(['/camper-profile/' + pet.id]);
        }
      });
  }
}
